import styled from "styled-components";

import { Link } from 'react-router-dom';

export const Container = styled.div``;

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 72px 0 50px;

  position: relative;

  .historic__wrapper{
    width: 90%;
    max-width: 1400px;
    height: fit-content;
    margin: 0 auto;
  }

  .historic__filter{
    max-width: 320px;
  }

  .historic__li:not(:first-of-type){
    margin-top: 31.9px;
  }

  .historic__article{
    width: 100%;
    max-width: 1204px;
    height: fit-content;

    border-radius: 17px;
  }

  .historic__ul{
    width: 95%;
    margin: 35.4px auto 0;
  }

  .historic__article{
    width: 100%;
    max-width: 544.88px;
    height: fit-content;
    padding: 26.6px 25px 15.6px;
  }

  .historic__article-content{
    width: 100%;
    height: fit-content;

    display: flex;
  }

  .historic__icon-container{
    /* flex: 1; */
    padding-right: 22px;

    > svg {
      width: 100%;
      max-width: 39.76px;
      height: auto;
      aspect-ratio: 39.76 / 51.75;
    }
  }

  .historic__details-container{
    flex: 1;
    padding-right: 60px;

    position: relative;
  }

  .historic__details-title{
    display: block;

    color: var(--blue00);
    font-size: 1.0625rem;
    word-wrap: wrap;
    white-space: wrap;
  }

  .historic__details-service-name{
    text-transform: uppercase;
  }

  .historic__details-item{
    margin-top: 9px;

    display: block;

    color: #001383;
    font-size: 0.75rem;
  }

  .historic__details-id{
    position: absolute;
    top: 0;
    right: 0;

    font-size: 0.75rem;
  }

  .historic__details-button{
    width: 100%;
    max-width: 230.24px;
    height: fit-content;
    min-height: 36.63px;
    margin: 15.5px 0 0 auto;

    display: block;

    border-radius: 17px;
    border: 0;
    background-color: var(--blue00);
    cursor: pointer;

    color: #fff;
    font-size: 1.0625rem;
  }

  @media (max-width: 1170px){
    width: 100%;
    margin: 0;
    padding: 72px 0 150px;
  }
`;

export const ReturnButton = styled(Link)`
  position: absolute;
  top: 29px;
  left: 32px;

  .historic__content-icon{
    height: 20px;
    width: auto;
    stroke: #000;
  }
`
